
const productIndexName = 'grafikr-com-products';

const formatMoney = (cents, format) => {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "{{amount}}";

  const formatWithDelimiters = (number, precision, thousands, decimal) => {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

const formatPrice = function(price) {
  return new Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active
  }).format(price);
}


// A function that saves the aa event convertedObjectIDsAfterSearch, when clicking on a product card
// this section storage will be owerwritten for each click
// when a product is added to the cart, , check if the product added to cart is the same as the product in the storage

document.documentElement.addEventListener("cart:change", function(event) {
  if (event.detail.baseEvent === "variant:add") {
    checkSemiConvertedProducts(event.detail.cart);
  }
});

document.documentElement.addEventListener("cart:product-added", function(event) {
  if (event.detail !== null && event.detail.cart !== null) {
    checkSemiConvertedProducts(event.detail.cart);
  }
});


const checkSemiConvertedProducts = (cart) => {
  const semiConvertedProducts = localStorage.getItem('semiConvertedProducts');

  if (semiConvertedProducts) {

    const semiConvertedProductsObject = JSON.parse(semiConvertedProducts);

    if (semiConvertedProductsObject[cart.items[0].product_id]) {
      const { queryID, objectIDs } = semiConvertedProductsObject[cart.items[0].product_id];

      aa('convertedObjectIDsAfterSearch', {
        index: productIndexName,
        eventName: 'Product added to cart after search',
        queryID: queryID,
        objectIDs: objectIDs
      });

      delete semiConvertedProductsObject[cart.items[0].product_id];
      localStorage.setItem('semiConvertedProducts', JSON.stringify(semiConvertedProductsObject));
    }
  }
}


const semiConvertedProducts = ({ productID, queryID, objectIDs }) => {

  const objectData = {
    index: productIndexName,
    eventName: 'Product added to cart after search',
    queryID: queryID,
    objectIDs: [objectIDs]
  }

  const localStorageObject = localStorage.getItem('semiConvertedProducts') ? JSON.parse(localStorage.getItem('semiConvertedProducts')) : {};

  if (localStorageObject[productID]) {
    delete localStorageObject[productID];
  }

  const objects = {
    ...localStorageObject,
    [productID]: objectData
  }

  if (Object.keys(objects).length > 20) {
    delete objects[Object.keys(objects)[0]];
  }

  localStorage.setItem('semiConvertedProducts', JSON.stringify(objects))
}


class trackClick extends HTMLElement {

  constructor() {
    super();
    this.settings = {
      queryID: this.getAttribute('data-query-id') || '',
      objectID: this.getAttribute('data-object-id') || '',
      position: this.getAttribute('data-position') || '',
      indexName: this.getAttribute('data-index-name') || '',
      index: this.getAttribute('data-index') || ''
    };
    this.click = this.click.bind(this);

  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener('click', this.click);
    this.addEventListener('contextmenu', this.click);
    this.addEventListener('auxclick', this.click);
  }

  removeEventListeners() {
    this.removeEventListener('click', this.click);
  }

  async click(event) {

    const link = event.composedPath().find(el => el.tagName === 'A');

    if (link) {
      const productID = this.dataset.productId;
      const objectID = this.dataset.objectId;
      const queryID = this.dataset.queryId;
      const position = Number(link.dataset.position);
      const indexName = link.dataset.indexName;

      if (objectID && indexName) {


        const hitObject = {
          objectID: objectID,
          queryID: queryID,
          position: position,
          indexName: indexName
        };

        if (typeof algoliaShopify !== 'undefined' && algoliaShopify.helpers) {
          algoliaShopify.helpers.handleItemClick(hitObject);
        }

        aa('clickedObjectIDsAfterSearch', {
          eventType: 'click',
          eventName: 'Hit Clicked',
          index: productIndexName,
          queryID: queryID,
          objectIDs: [objectID],
          positions: [position + 1],
        });

        semiConvertedProducts({ productID, queryID: this.settings.queryID, objectIDs: objectID });
      }
    }
  }
}

if (!customElements.get('track-click')) {
  customElements.define('track-click', trackClick);
}




const quickAddTemplate = function(product, index, queryID) {

  const html = `
    <custom-lazy-quick-add class="custom-quick-add" product-handle="${ product.handle }" data-object-id="${ product.objectID }" data-position="${ index }" data-query-id="${ queryID }">
      <button type="submit" class="hidden">
        <span class="sr-only">Add to cart</span>
      </button>

      <div class="product-card__quick-add-button custom-quick-add__open-button">
        <span class="sr-only">Add to cart</span>

        <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-plus" viewBox="0 0 12 12">
          <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.2"></path>
        </svg>
      </div>

      <div class="custom-quick-add__button-container">
        <div class="block-swatch-container">
          <div><button type="button" class="block-swatch">&nbsp;</button></div>
          <div><button type="button" class="block-swatch">&nbsp;</button></div>
          <div><button type="button" class="block-swatch">&nbsp;</button></div>
          <div><button type="button" class="block-swatch">&nbsp;</button></div>
          <div><button type="button" class="block-swatch">&nbsp;</button></div>
        </div>

        <button type="button" class="custom-quick-add__close-button">
          <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path>
          </svg>
        </button>
      </div>
    </custom-lazy-quick-add>
  `;

  return html;
}



const getProductCardTemplate = ({ product, index, queryID, quickAdd = false }) => {
  const itemUrl = new URL(`/products/${ product.handle }`, window.location.origin);
  const searchParams = new URLSearchParams();
  searchParams.set('queryid', queryID);
  itemUrl.search = searchParams.toString();

  const imageElement = document.createElement('img');
  const imageSizes = [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800];
  const imageUrl = new URL(product?.image?.src ? product.image.src : 'https://via.placeholder.com/300');

  imageUrl.searchParams.set('width', '1400');
  imageElement.src = imageUrl.toString();

  imageElement.srcset = imageSizes.map(size => {
    imageUrl.searchParams.set('width', size);
    return `${ imageUrl.toString() } ${ size }w`;
  }).join(', ');


  let indexLimit = 4;

  if (window.innerWidth < 1000 && window.innerWidth >= 700) {
    indexLimit = 3;
  } else if (window.innerWidth < 700) {
    indexLimit = 2;
  }

  imageElement.alt = product.title;
  imageElement.sizes = '(max-width: 699px) calc(100vw / 2), (max-width: 999px) calc(100vw / 0 - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))';
  imageElement.loading = index <= indexLimit ? 'eager' : 'lazy';
  imageElement.fetchPriority = index <= indexLimit ? 'high' : 'low';
  imageElement.classList.add('product-card__image', 'product-card__image--primary', themeVariables.settings.aspectRatioClass);
  imageElement.style = 'object-fit: cover;';
  imageElement.width = 1400;

  const badges = product.meta?.custom?.badges ?? [];

  const badgesHTML = badges.map(badge => {
    return badge !== '' ? `<span class="badge badge--custom badge--${ badge }">${ badge }</span>` : '';
  }).join('');


  const html = `
    <url-preload>
    <track-click  
      data-product-id="${ product.id }"
      data-object-id="${ product.objectID }"
      data-position="${ index }"
      data-query-id="${ queryID }"
      data-index-name="${ productIndexName }"

    >
    <product-card class="product-card" handle="${ product.handle }">
      <div class="product-card__figure">
        ${ badgesHTML ? `<badge-list class="badge-list badge-list--vertical">${ badgesHTML }</badge-list>` : '' }

        <a
          data-product-id="${ product.id }"
          data-object-id="${ product.objectID }"
          data-position="${ index }"
          data-index-name="shopify_products"
          href="${ itemUrl }"
          class="product-card__media"
        >
          ${ imageElement.outerHTML }
        </a>

        ${ quickAdd ? quickAddTemplate(product, index, queryID) : '' }
      </div>

      <div class="product-card__info empty:hidden">
        <div class="v-stack justify-items-center gap-2">
          <div class="v-stack justify-items-center gap-1">
            <a
              data-product-id="${ product.id }"
              data-object-id="${ product.objectID }"
              data-position="${ index }"
              data-index-name="shopify_products"
              href="${ itemUrl }"
              class="product-title  "
            >
              ${ product.title }
            </a>

            <price-list class="price-list ">
              <sale-price class="${ product.compare_at_price && product.compare_at_price > product.price ? 'text-on-sale' : '' }">
                <span class="sr-only">${ window.themeVariables.strings.product.price.salePrice }</span>
                ${ formatMoney(product.price, themeVariables.settings.moneyFormat) }
              </sale-price>
              ${ product.compare_at_price && product.compare_at_price > product.price ? `
                <compare-at-price class="line-through">
                  <span class="sr-only">${ window.themeVariables.strings.product.price.regularPrice }</span>${ formatMoney(product.compare_at_price, themeVariables.settings.moneyFormat) }
                </compare-at-price>
              ` : ''
    }
            </price-list>
          </div>
        </div>
      </div>
      </product-card>
      </track-click>
    </url-preload>
  `;

  return html;
}

export {
  formatPrice,
  trackClick,
  getProductCardTemplate
};
